<template>
  <details v-if="rows.length" class="ps-history">
    <summary>آخرین تغییرات مدیران</summary>
    <ol><li v-for="row in rows" :key="row.id"><strong>{{ row.actor }}</strong><time :datetime="row.at">{{ date(row.at) }}</time>
      <span v-if="row.after.active && Array.isArray(row.after.active)">{{ row.after.province }} · {{ row.after.active.length.toLocaleString('fa-IR') }} شهر فعال<span v-if="row.after.name"> · {{ row.after.name }}</span></span>
      <span v-else>{{ row.before.title ? row.before.title + ' ← ' : '' }}{{ row.after.title }} · {{ row.after.active ? 'نمایان' : 'پنهان' }}</span>
    </li></ol>
  </details>
</template>
<script>
export default { props: { rows: { type: Array, default: () => [] } }, methods: { date(value) { return new Date(value).toLocaleString('fa-IR'); } } };
</script>
